import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./Cookies.module.css";
import { Link } from "react-router-dom";
import illustration from "../../assets/hero.png";

export default function CookiesPage() {
  const { t } = useTranslation("footer");
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem("cookie-consent");
    try {
      const parsed = raw ? JSON.parse(raw) : raw;
      setConsent(parsed || null);
    } catch {
      setConsent(raw || null);
    }
  }, []);

  function clearConsent() {
    localStorage.removeItem("cookie-consent");
    setConsent(null);
    window.location.reload(); // optional — refresh so banner reappears
  }

  return (
    <main className={css.page}>
      <div className={css.hero}>
        <div className={css.heroText}>
          <h1>{t("cookies.title")}</h1>
          <p className={css.lead}>{t("cookies.lead")}</p>
          <div className={css.metaRow}>
            <span className={css.metaBadge}>{t("cookies.badge1")}</span>
            <span className={css.metaBadge}>{t("cookies.badge2")}</span>
            <span className={css.metaBadge}>
              {t("cookies.badge3")} (opt-in)
            </span>
          </div>
        </div>

        <figure className={css.heroImageWrap} aria-hidden>
          <img src={illustration} alt="" className={css.heroImage} />
        </figure>
      </div>

      <section className={css.container}>
        <article className={css.card}>
          <h2>{t("cookies.whatAreTitle")}</h2>
          <p>{t("cookies.whatAreText")}</p>
        </article>

        <article className={css.card}>
          <h2>{t("cookies.whichAreTitle")}</h2>

          <h3>{t("cookies.whichAreSubtitle1")}</h3>
          <p>{t("cookies.whichAreText1")}</p>

          <h3>{t("cookies.whichAreSubtitle2")}</h3>
          <p>{t("cookies.whichAreText2")}</p>

          <h3>{t("cookies.whichAreSubtitle3")}</h3>
          <p>{t("cookies.whichAreText3")}</p>
        </article>

        <article className={css.card}>
          <h2>{t("cookies.controlTitle")}</h2>
          <p>{t("cookies.controlText")}</p>

          <div className={css.controls}>
            <div>
              <strong>{t("cookies.status")}</strong>{" "}
              <span className={css.status}>
                {consent === null
                  ? "Sem decisão"
                  : typeof consent === "string"
                  ? consent
                  : JSON.stringify(consent)}
              </span>
            </div>

            <div className={css.controlsBtns}>
              <button
                className={css.btnGhost}
                onClick={() => window.location.reload()}
              >
                {t("cookies.bannerButton")}
              </button>
              <button className={css.btnDanger} onClick={clearConsent}>
                {t("cookies.cleanButton")}
              </button>
            </div>
          </div>
        </article>

        <article className={css.card}>
          <h2>{t("cookies.consequencesTitle")}</h2>
          <p>{t("cookies.consequencesText")}</p>

          <h3>{t("cookies.consequencesSubtitle")}</h3>
          <p>{t("cookies.consequencesSubText")}</p>
        </article>

        <article className={css.cardSmall}>
          <h3>{t("cookies.doubtsTitle")}</h3>
          <p>{t("cookies.doubtsText")}</p>
          <p className={css.linkRow}>
            <Link to="/privacy" className={css.inlineLink}>
              {t("cookies.policy")}
            </Link>
            <Link to="/terms" className={css.inlineLink}>
              {t("terms.title")}
            </Link>
          </p>
        </article>
      </section>
    </main>
  );
}
